import type { OpenItemEventType, OpenItemStatus } from '../api/dto.js';
import { OPEN_ITEM_STATUSES } from '../api/dto.js';

/** What a status change means (decision O2): `resolved` is the end state, leaving it reopens. */
export type StatusChange = 'none' | 'progress' | 'resolve' | 'reopen';

export function statusChange(from: OpenItemStatus, to: OpenItemStatus): StatusChange {
  if (from === to) return 'none';
  if (to === 'resolved') return 'resolve';
  return from === 'resolved' ? 'reopen' : 'progress';
}

/** History entry type of a status change (`null` = nothing changed). */
export function statusEventType(
  from: OpenItemStatus,
  to: OpenItemStatus,
): Extract<OpenItemEventType, 'status' | 'reopened'> | null {
  const change = statusChange(from, to);
  if (change === 'none') return null;
  return change === 'reopen' ? 'reopened' : 'status';
}

/** `resolvedAt` after a status change: set on resolve, cleared on reopen, else unchanged. */
export function resolvedAtAfter<T>(
  from: OpenItemStatus,
  to: OpenItemStatus,
  previous: T | null,
  now: T,
): T | null {
  const change = statusChange(from, to);
  if (change === 'resolve') return now;
  return change === 'reopen' ? null : previous;
}

/** Workflow order Open → In progress → Waiting for… → Resolved; after Resolved comes a reopen. */
export function nextStatus(s: OpenItemStatus): OpenItemStatus {
  const i = OPEN_ITEM_STATUSES.indexOf(s);
  return OPEN_ITEM_STATUSES[(i + 1) % OPEN_ITEM_STATUSES.length]!;
}

export function statusRank(s: OpenItemStatus): number {
  return OPEN_ITEM_STATUSES.indexOf(s);
}
